// Key presence, not value definedness — `{ k: undefined }` counts as enabled.
const hasExperiments = (experiments) => Object.keys(experiments ?? {}).length > 0;
export { hasExperiments };
